var _excluded = ["event_type", "device_id", "device_platform", "device_os", "device_model", "topic", "event_attr"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * @file 视频相关上报
 * @author dafo<huanghouin@baijiahulian.com>
 * @module module/video
 */
/* eslint-disable camelcase */
import request from './util/request';
import { camelToUnder } from './util/json';
import configurable from './util/configurable';
import { Config } from './util/config';

/**
 * 数据上报
 *
 * @function
 * @param {Object} json 要上报的数据
 * @param {Function=} callback 上报后的回调
 */
var report = configurable(function (json, callback) {
  // 字段解析见 http://ewiki.baijiahulian.com//大数据团队/数据方向/大数据/旧项目文档/batch_event事件上报.md
  var _camelToUnder = camelToUnder(json),
    _camelToUnder$event_t = _camelToUnder.event_type,
    event_type = _camelToUnder$event_t === void 0 ? '3' : _camelToUnder$event_t,
    device_id = _camelToUnder.device_id,
    device_platform = _camelToUnder.device_platform,
    device_os = _camelToUnder.device_os,
    device_model = _camelToUnder.device_model,
    _camelToUnder$topic = _camelToUnder.topic,
    topic = _camelToUnder$topic === void 0 ? 'video_info' : _camelToUnder$topic,
    event_attr = _camelToUnder.event_attr,
    rest = _objectWithoutProperties(_camelToUnder, _excluded);

  // 补充其它必要上报数据
  var videokLogData = _objectSpread({
    // 当前页面 URL
    url: location.href,
    // 事件 id
    event_type: event_type,
    device_id: device_id,
    device_platform: device_platform,
    device_os: device_os,
    device_model: device_model,
    topic: topic,
    event_attr: event_attr
  }, rest);
  request('post')("".concat(Config.BATCH), '', callback, [videokLogData]);
}, {
  event_attr: {}
});
export default report;